<template>
  <a-layout-header :class="'default-header'" :hasSider="false">
    <slot></slot>
  </a-layout-header>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.default {
  &-header {
    position: sticky;
    top: 0;
    z-index: $header-index;

    display: flex;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-height: $header-height;
    padding: 0 16px;
    border: 1px solid transparent;
    //  margin-bottom: 21px;

    background: $primary; // fallback
    background: $header-background-color;
    // color: $header-text-color;
    // font-size: 20px;

    align-items: center;
  }
}
</style>
